import Gate from '@/plugins/vue-gate/Gate.js';
import ActivityLogPolicy from '@/policies/ActivityLogPolicy.js';
import ActivityPolicy from '@/policies/ActivityPolicy.js';
import ActivitySubmissionPolicy from '@/policies/ActivitySubmissionPolicy.js';
import ActivityUpdatePolicy from '@/policies/ActivityUpdatePolicy.js';
import AnomalyDetectionPolicy from '@/policies/AnomalyDetectionPolicy.js';
import AttemptAuthorizationPolicy from '@/policies/AttemptAuthorizationPolicy.js';
import AttendanceCommentPolicy from '@/policies/AttendanceCommentPolicy.js';
import AttendancePolicy from '@/policies/AttendancePolicy.js';
import AutomatedSurveyPolicy from '@/policies/AutomatedSurveyPolicy.js';
import CourseAnnouncementPolicy from '@/policies/CourseAnnouncementPolicy.js';
import CourseCodePolicy from '@/policies/CourseCodePolicy.js';
import CourseEnrollmentPolicy from '@/policies/CourseEnrollmentPolicy.js';
import CourseGroupPolicy from '@/policies/CourseGroupPolicy.js';
import CourseLogEntryPolicy from '@/policies/CourseLogEntryPolicy.js';
import CoursePolicy from '@/policies/CoursePolicy.js';
import CourseTemplateGroupPolicy from '@/policies/CourseTemplateGroupPolicy.js';
import CourseTemplatePolicy from '@/policies/CourseTemplatePolicy.js';
import DiscussionReplyPolicy from '@/policies/DiscussionReplyPolicy.js';
import DiscussionThreadPolicy from '@/policies/DiscussionThreadPolicy.js';
import EbookPolicy from '@/policies/EbookPolicy.js';
import EvaluationTemplatePolicy from '@/policies/EvaluationTemplatePolicy.js';
import GradebookGradePolicy from '@/policies/GradebookGradePolicy.js';
import GradebookPolicy from '@/policies/GradebookPolicy.js';
import GroupPolicy from '@/policies/GroupPolicy.js';
import InstitutionSettingPolicy from '@/policies/InstitutionSettingPolicy.js';
import IntegrationsPolicy from '@/policies/IntegrationsPolicy.js';
import InterventionPolicy from '@/policies/InterventionPolicy.js';
import ItemHeaderPolicy from '@/policies/ItemHeaderPolicy.js';
import LocationPolicy from '@/policies/LocationPolicy.js';
import MeetingPolicy from '@/policies/MeetingPolicy.js';
import MessagePolicy from '@/policies/MessagePolicy.js';
import NotePolicy from '@/policies/NotePolicy.js';
import PagePolicy from '@/policies/PagePolicy.js';
import QuizAttemptPolicy from '@/policies/QuizAttemptPolicy.js';
import QuizDashboardPolicy from '@/policies/QuizDashboardPolicy.js';
import QuizPolicy from '@/policies/QuizPolicy.js';
import RemediationPolicy from '@/policies/RemediationPolicy.js';
import ReportPolicy from '@/policies/ReportPolicy.js';
import RubricBankPolicy from '@/policies/RubricBankPolicy.js';
import SlideDeckPolicy from '@/policies/SlideDeckPolicy.js';
import StatusPolicy from '@/policies/StatusPolicy.js';
import TermSchedulePolicy from '@/policies/TermSchedulePolicy.js';
import TermTemplatePolicy from '@/policies/TermTemplatePolicy.js';
import TimePeriodPolicy from '@/policies/TimePeriodPolicy.js';
import TimePeriodTemplatePolicy from '@/policies/TimePeriodTemplatePolicy.js';
import UserGroupPolicy from '@/policies/UserGroupPolicy.js';
import UserPolicy from '@/policies/UserPolicy.js';
import VideoPolicy from '@/policies/VideoPolicy.js';
import store from '@/store/Index.js';

Gate.registerPolicy(ActivityPolicy, 'Activity');
Gate.registerPolicy(ActivitySubmissionPolicy, 'ActivitySubmission');
Gate.registerPolicy(CoursePolicy, 'Course');
Gate.registerPolicy(CourseTemplatePolicy, 'CourseTemplate');
Gate.registerPolicy(CourseEnrollmentPolicy, 'CourseEnrollment');
Gate.registerPolicy(DiscussionThreadPolicy, 'DiscussionThread');
Gate.registerPolicy(QuizAttemptPolicy, 'QuizAttempt');
Gate.registerPolicy(QuizDashboardPolicy, 'QuizDashboard');
Gate.registerPolicy(GradebookGradePolicy, 'GradebookGrade');
Gate.registerPolicy(EbookPolicy, 'Ebook');
Gate.registerPolicy(ReportPolicy, 'Report');
Gate.registerPolicy(ItemHeaderPolicy, 'ItemHeader');
Gate.registerPolicy(CourseGroupPolicy, 'CourseGroup');
Gate.registerPolicy(CourseTemplateGroupPolicy, 'CourseTemplateGroup');
Gate.registerPolicy(VideoPolicy, 'Video');
Gate.registerPolicy(SlideDeckPolicy, 'SlideDeck');
Gate.registerPolicy(MeetingPolicy, 'Meeting');
Gate.registerPolicy(QuizPolicy, 'Quiz');
Gate.registerPolicy(RubricBankPolicy, 'RubricBank');
Gate.registerPolicy(EvaluationTemplatePolicy, 'EvaluationTemplate');
Gate.registerPolicy(UserPolicy, 'User');
Gate.registerPolicy(GroupPolicy, 'Group');
Gate.registerPolicy(UserGroupPolicy, 'UserGroup');
Gate.registerPolicy(LocationPolicy, 'Location');
Gate.registerPolicy(MessagePolicy, 'Message');
Gate.registerPolicy(PagePolicy, 'Page');
Gate.registerPolicy(CourseAnnouncementPolicy, 'CourseAnnouncement');
Gate.registerPolicy(ActivityUpdatePolicy, 'ActivityUpdate');
Gate.registerPolicy(CourseLogEntryPolicy, 'CourseLogEntry');
Gate.registerPolicy(TimePeriodPolicy, 'TimePeriod');
Gate.registerPolicy(TimePeriodTemplatePolicy, 'TimePeriodTemplate');
Gate.registerPolicy(ActivityLogPolicy, 'ActivityLog');
Gate.registerPolicy(AttendancePolicy, 'Attendance');
Gate.registerPolicy(StatusPolicy, 'Status');
Gate.registerPolicy(DiscussionReplyPolicy, 'DiscussionReply');
Gate.registerPolicy(GradebookPolicy, 'Gradebook');
Gate.registerPolicy(AttendancePolicy, 'Attendance');
Gate.registerPolicy(AttendanceCommentPolicy, 'AttendanceComment');
Gate.registerPolicy(CourseCodePolicy, 'CourseCode');
Gate.registerPolicy(AttemptAuthorizationPolicy, 'AttemptAuthorization');
Gate.registerPolicy(RemediationPolicy, 'Remediation');
Gate.registerPolicy(AutomatedSurveyPolicy, 'AutomatedSurvey');
Gate.registerPolicy(NotePolicy, 'Note');
Gate.registerPolicy(TermTemplatePolicy, 'TermTemplate');
Gate.registerPolicy(TermSchedulePolicy, 'TermSchedule');
Gate.registerPolicy(InstitutionSettingPolicy, 'InstitutionSetting');
Gate.registerPolicy(InterventionPolicy, 'Intervention');
Gate.registerPolicy(AnomalyDetectionPolicy, 'AnomalyDetection');
Gate.registerPolicy(IntegrationsPolicy, 'Integrations');
export const gate = new Gate(store);

export default app => {
    app.config.globalProperties.$gate = gate;

    app.gate = gate;
};
